import {replace} from 'react-router-redux'
import {clearHistory} from '../core/redux/router'
import {infoStatus} from '../core/redux/status'
import {updateActiveUserCmd, updateResetPasswordCmd, sendResetLoginCmd, loadAuthenticatedUserConfigs} from './actions'
import i18n from './i18n'
import UnauthUserLayout from './components/UnauthUserLayout'
import AccountLayout from './components/AccountLayout'
import AccountDetail from './components/AccountDetail'
import LoginBox from './components/LoginBox'
import ActiveUserBox from './components/ActiveUserBox'
import ResetPasswordDemandBox from './components/ResetPasswordDemandBox'
import ResetPasswordBox from './components/ResetPasswordBox'

function enterResetLogin(dispatch, params, query) {
    return dispatch(sendResetLoginCmd({verificationCode: params.code, userId: params.uid, login: query.login})).then(() => {
        return dispatch(replace('/login'))
    }).then(() => {
            return dispatch(clearHistory())
    }).then(() => {
        return dispatch(infoStatus(i18n.loginResetted))
    })
}

export function loginRoute(rootPath, dispatcher) {
    return {
        path: rootPath,
        component: UnauthUserLayout,
        indexRoute: {
            component: LoginBox
        }
    }
}

export function activeUserRoute(rootPath, dispatcher) {
    return {
        path: rootPath + '/:code/:uid',
        component: UnauthUserLayout,
        indexRoute: {
            component: ActiveUserBox,
            onEnter: dispatcher((d, p) => d(updateActiveUserCmd({activationCode: p.code, userId: p.uid})))
        }
    }
}

export function forgotPasswordRoute(rootPath, dispatcher) {
    return {
        path: rootPath,
        component: UnauthUserLayout,
        indexRoute: {   
            component: ResetPasswordDemandBox
        }
    }
}

export function resetPasswordRoute(rootPath, dispatcher) {
    return {
        path: rootPath + '/:code/:uid',
        component: UnauthUserLayout,
        indexRoute: {
            component: ResetPasswordBox,
            onEnter: dispatcher((d, p) => d(updateResetPasswordCmd({verificationCode: p.code, userId: p.uid})))
        }
    }
}

export function resetLoginRoute(rootPath, dispatcher) {
    return {
        path: rootPath + '/:code/:uid',
        indexRoute: {
            onEnter: dispatcher(enterResetLogin)
        }
    }
}

export function accountRoute(rootPath, dispatcher) {
    return {
        path: rootPath,
        component: AccountLayout,
        indexRoute: {
            component: AccountDetail,
            onEnter: dispatcher((d, p) => d(loadAuthenticatedUserConfigs()))
        }
    }
}


// WEBPACK FOOTER //
// ./lib/user/routes.js